import { lazy } from 'react'

export const AuthLazy = lazy(() => import('./Auth'))
